module.exports = __webpack_public_path__ + "img/magic prep.56118c72.png";